import { useEffect, useState } from "react";
import { Room, RoomEvent, RemoteParticipant } from "livekit-client";

export function useRemoteParticipants(room?: Room) {
  const [participants, setParticipants] = useState<RemoteParticipant[]>([]);

  useEffect(() => {
    if (!room) return;
    const update = () =>
      setParticipants(Array.from(room.remoteParticipants.values()));

    update();
    room.on(RoomEvent.ParticipantConnected, update);
    room.on(RoomEvent.ParticipantDisconnected, update);

    return () => {
      room.off(RoomEvent.ParticipantConnected, update);
      room.off(RoomEvent.ParticipantDisconnected, update);
    };
  }, [room]);

  return participants;
}
